import { lazy } from 'react';
import { useMfPersonalSettingsConfig } from './useMfPersonalSettingsConfig';

const Mfe = lazy(() => import('mfPersonalSettings/PersonalSettings'));

function PersonalSettings() {
  const config = useMfPersonalSettingsConfig();

  return (
    <div
      style={{ display: 'contents' }}
      data-testid="adm.personalSettings.wrapper"
    >
      <Mfe {...config} />
    </div>
  );
}

export default PersonalSettings;
